import { render, staticRenderFns } from "./WaitAllmodel.vue?vue&type=template&id=6215f4b0&scoped=true&"
import script from "./WaitAllmodel.vue?vue&type=script&lang=js&"
export * from "./WaitAllmodel.vue?vue&type=script&lang=js&"
import style0 from "./WaitAllmodel.vue?vue&type=style&index=0&id=6215f4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215f4b0",
  null
  
)

export default component.exports